<template>
    <button v-if="isMic" class="room__control room__mic r-button" type="button" @click="switchMic(false)">
        <span class="room__control-text">Выключить микрофон</span>
    </button>
    <button v-else class="room__control room__mic-off r-button" type="button" @click="switchMic(true)">
        <span class="room__control-text">Включить микрофон</span>
    </button>
</template>

<script>
    import {mapMutations, mapState} from 'vuex';

    export default {
        name: "MicSwitch",
        computed: {
            ...mapState('conference', [
                'isMic'
            ])
        },
        methods: {
            ...mapMutations('conference', [
                'switchMic'
            ])
        }
    }
</script>
